/**
 * ユーザー関連の型定義（統合版）
 * ユーザープロファイル、権限、API関連の型
 */

// =============================================================================
// ユーザーロール定義
// =============================================================================

/**
 * ユーザーロール
 */
export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];

// =============================================================================
// ユーザープロファイル型定義
// =============================================================================

/**
 * プロファイル
 */
export interface Profile {
  id: string;
  email: string;
  username: string | null;
  name: string | null;
  role: UserRole;
  is_active: boolean;
  craftsman_id: string | null;
  created_at: string;
  updated_at: string;
}

// =============================================================================
// API関連の型定義
// =============================================================================

/**
 * ユーザー取得パラメータ
 */
export interface GetUsersParams {
    /** スキップ数 */
    skip?: number
    /** 取得件数 */
    limit?: number
    /** アクティブ状態 */
    is_active?: boolean
    /** ユーザーロール */
    role?: UserRole
}

/**
 * ユーザー作成データ
 */
export interface CreateUserData {
    /** ユーザー名 */
    username: string
    /** 表示名 */
    name: string
    /** ユーザーロール */
    role: UserRole
    /** アクティブ状態 */
    is_active?: boolean
    /** 職人ID */
    craftsman_id?: string | null
}

/**
 * ユーザー更新データ
 */
export interface UpdateUserData extends Partial<Pick<Profile, 'username' | 'name' | 'role' | 'is_active' | 'craftsman_id'>> {}

/**
 * ユーザー統計
 */
export interface UserStats {
    /** 総数 */
    total: number
    /** アクティブ数 */
    active: number
    /** 非アクティブ数 */
    inactive: number
    /** 管理者数 */
    admins: number
    /** 一般ユーザー数 */
    users: number
}

/**
 * ユーザー一覧レスポンス
 */
export interface UsersListResponse {
    items: Profile[]
    total: number
}